//存放主站域名
const BASE_URL = 'https://keralagame.in/userapi/v1'  //正式域名
// const BASE_URL = 'http://game.xingnuo.tech/userapi/v1'  //测试域名


//生成请求方法
function request(params) { // 传参：params参数
    let {
        url, //	请求地址
        data = {}, //	参数信息
        method = 'POST', //	请求方式
        headers = {
            'content-type': 'application/json' // application/x-www-form-urlencoded
        }, //	请求头信息
    } = params
    return new Promise((resolve, reject) => {
        data.token = localStorage.getItem("token") == 'null' ? '' : localStorage.getItem("token")
        this.$axios({
            method: method,
            headers: headers, // 请求头
            url: BASE_URL + url,
            data: data,
            // data: this.$qs.stringify(data),
            xhrFields: {
                withCredentials: true
            }
        }).then((res) => {
            console.log(res,'11111111111111111')
            // 获取接口状态
            const soleData = res.data
            const {
                code
            } = soleData
          
            if (code == 1) {
                resolve(soleData)
            } else {
                // console.log(soleData)
                reject(soleData)
            }
        }).catch(error => {
            // if(error.response.status == 400){
            //     this.$toast({
            //         message:error.response.data.msg,
            //         duration: 1500,
            //       });
            //     this.$router.push('register')
            //     return
            // }
            reject(error)
        })
    })
}

module.exports = {
    BASE_URL,
    request
}